// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-bdc8a008] .ant-modal-body {\n  padding: 10px 24px 24px;\n}\n.tips[data-v-bdc8a008] {\n  margin-bottom: 5px;\n  color: #f59a23;\n  padding: 5px 10px;\n  background: rgb(255, 245, 235);\n  font-size: 12px;\n}", ""]);
// Exports
module.exports = exports;
